import * as React from 'react'
import { range } from 'app/service/util'
import * as Sound from 'app/service/sound'
import DocumentEventHandler from 'app/comp/document-event-handler'



export default class Combo extends React.Component<{
  code: string
  onSolve: () => void
}, {
  value: string
  isFocused: boolean
}> {

  constructor(props) {
    super(props)

    this.state = {
      value: '',
      isFocused: false
    }
  }

  reset() {
    this.setState({isFocused: false, value: ''})
  }

  handleGlobalClick = event => {
    if (!event.target.closest('.combo')) {
      this.reset()
    }
  }

  handleKeyUp = event => {
    if (!this.state.isFocused) {
      return
    }

    // escape
    if (event.which == 27) {
      this.reset()
      return
    }

    // delete
    if (event.which == 8) {
      this.setState({value: this.state.value.slice(0, this.state.value.length - 1)})
      return
    }

    const l = String.fromCharCode(event.which)

    if (/^[a-zA-Z0-9]*$/.test(l)) {
      const nextValue = this.state.value + l.toUpperCase()

      if (nextValue.length == this.props.code.length) {
        if (nextValue == this.props.code) {
          this.props.onSolve()
        } else {
          Sound.playNote(0)
          this.setState({value: ''})
        }
      } else {

        Sound.playNote(nextValue.length)

        this.setState({value: nextValue})
      }
    }
  }

  handleClick = () => {
    this.setState({isFocused: true})
  }

  render() {
    const {
      value,
      isFocused
    } = this.state

    const blockStyle: any = {
      width: 50,
      height: 50,
      marginLeft: 4,
      marginRight: 4,
      border: 'none',
      borderRadius: 3,
      backgroundColor: 'rgba(0, 0, 0, 0.1)',
      fontSize: 30,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      outline: 'none',
      color: '#222',
      zIndex: 100,
      cursor: 'text'
    }

    const focusedStyle = {
      ...blockStyle,
      backgroundColor: 'rgba(0, 0, 0, 0.2)'
    }

    return (
      <div className="combo" onClick={this.handleClick} style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>

        <DocumentEventHandler
          onKeyUp={this.handleKeyUp}
          onClick={this.handleGlobalClick}
        />

        {range(this.props.code.length).map(i =>
          <div
            key={i}
            style={
              isFocused && (
                (value[i - 1] || i == 0) && !value[i]
              ) ? focusedStyle : blockStyle
            }
          >
            {value[i] || ''}
          </div>
        )}
      </div>
    )
  }

}


// WEBPACK FOOTER //
// ./src/comp/combo.tsx